var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conditional-select" },
    [
      _c(
        "form-field-select",
        _vm._b(
          {
            attrs: { items: _vm.items, messages: _vm.messages },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          },
          "form-field-select",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _vm.value
        ? _c(
            "div",
            { staticClass: "conditional-select--conditional-field" },
            [_vm._t(_vm.slotName, null, { messages: _vm.messages })],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f7c3aca", { render: render, staticRenderFns: staticRenderFns })
  }
}